export class ZIndex
{
    public static readonly BonusJackpotWin: number = 500;

    public static readonly BonusPickContainer: number = 100;

    public static readonly BonusCofirmMessage: number = 450;

    public static readonly BonusReelView: number = 100;
    public static readonly BonusReelOverlay: number = 100;

    public static readonly BonusFountain: number = 300
    public static readonly BonusTransition: number = 900;
    public static readonly BonusTransitionTitle:number=990;
    public static readonly FreeGameIntroText: number = 999;
    
    //public static readonly BonusPickComet: number = 151;
    public static readonly BonusWin: number = 100;
    public static readonly Jp1Comet: number = 250;
    public static readonly Jp2Comet: number = 250;
    public static readonly Jp3Comet: number = 250;
    public static readonly Jp4Comet: number = 250;

    public static readonly JPTitle: number = 800;

    public static readonly Menu:number = 1500;

    public static readonly PresentationVideo:number = 989;

    public static readonly Malfunction: number = 899;

    
    public static readonly Robot: number = 910;
    public static readonly ReplayMessage: number = 910;
    
    public static readonly Panel: number = 400;
    public static readonly WinCount: number = 310;
    public static readonly InGameMenuBackground = 600;
    
    public static readonly JackpotDisplay: number = 99;
    public static readonly JackpotDisplayBackground: number = 0;
    public static readonly HoldAndStopBonusStats:number=10;
    public static readonly HoldAndStopTitle:number=5;
    
    public static readonly ReelContainer: number = 1;
    public static readonly ReelContainerBackground: number = 0;
    public static readonly DemonContainer: number = 600;
    public static readonly Lock: number = 1399;
    public static readonly BetTypeMenu = 1400;
    public static readonly CallAttendantMenu: number = 1401;
    public static readonly PayoutMenu: number = 1402;
    public static readonly WildBulk: number = 50;
    public static readonly WildBulkReel: number = 50;
    public static readonly HoldingFeature: number = 50;
    public static readonly WinLines: number = 60;
    public static readonly ResponsivePanel:number = 450;
    public static readonly HelpInfo:number = 500;
    public static readonly SpinAndHoldReels:number = 2;
    public static readonly IntroContainer:number = 450;
    public static readonly StickySpin:number = 1;
    public static readonly WinContainerBigFG:number=10;
    public static readonly freegameStats2: number=1;
    public static readonly backgroundBaseGame: number = -1;
    public static readonly winValueSprite: number = 1;
    public static readonly SettingsMenu: number = 450;
    public static readonly JPType: number = 3;
    public static readonly DoubleGame: number = 401;


    public static readonly PlusOne: number = 50;

    public static readonly DemoMessage:number =  890;

    public static readonly MenuLiveBackground : number = -2;
    //public static readonly MenuLiveBackgroundHide : number = -1;

    public static readonly ElementsMenu :  number = 2;
    public static readonly JPWinVideo: number = 2;

    public static readonly FullScreen: number = 10000;
    
    public static readonly BackgroundBonus : number = 2

    public static readonly LoadingContainer: number = 1410;

    public static readonly PinView: number = 1450;
    public static readonly HealthMonitor: number = 1451;
}
